import { API_URLS } from '@/configs';
import { fetchData } from '.';
import { type GenericResponse } from './base';

export interface GoogleMapsSuggestion {
  place_id: string;
  main_text: string;
  secondary_text: string;
  types: string[];
}

export interface GoogleMapsGeocode {
  place_id: string;
  bounds: {
    northeast: {
      lat: number;
      lng: number;
    };
    southwest: {
      lat: number;
      lng: number;
    };
  };
}

export type GetGoogleMapsAutocompleteResponse = GenericResponse<
  GoogleMapsSuggestion[]
>;
export type GetGoogleMapsGeocodeResponse = GenericResponse<GoogleMapsGeocode>;

export const getGoogleMapsAutocomplete = (
  input: string,
): Promise<GetGoogleMapsAutocompleteResponse> => {
  const url = new URL(`${API_URLS.BASE}/google-maps/autocomplete/`);
  url.searchParams.append('input', input);
  return fetchData(url);
};

export const getGoogleMapsGeocode = (
  placeId: string,
): Promise<GetGoogleMapsGeocodeResponse> => {
  const url = new URL(`${API_URLS.BASE}/google-maps/geocode/`);
  url.searchParams.append('place_id', placeId);
  return fetchData(url);
};
